import { ChangeEvent, useContext, useEffect, useState } from 'react';
import { OperationCenterType } from '../../../../models/operations-center/operationsCenterType';
import { OperationsCenterRepository } from '../../../../services/external/APIs/operations-center/OperationsCenter.api';
import { AppContext } from '../../../context';
import { Modal } from '../BaseModal';

import SimpleBar from 'simplebar-react';
import { SearchField } from '../../search-field/SearchField';

interface Props {
    isOpen: boolean;
    save: (
        initDate: string,
        lastDate: string,
        employeeIds: (string | number)[],
        operationCenterId: number
    ) => void;
}

export const OperationsCenterModal = ({ isOpen, save }: Props) => {
    const { modalInfoOperationsCenter, setIsOpenOperationsCenterModal } =
        useContext(AppContext);

    const [searchTerm, setSearchTerm] = useState('');
    const [operationsCenter, setoperationsCenter] = useState<OperationCenterType[]>(
        []
    );
    const [operationsCenterCopy, setOperationsCenterCopy] = useState<
        OperationCenterType[]
    >([]);
    const [selectedId, setSelectedId] = useState<number>(-1);
    const [isLoading, setIsLoading] = useState(false);

    const handlerCloseModal = () => {
        window.localStorage.removeItem('selection-range');
        setIsOpenOperationsCenterModal(false);
    };

    const handlerSelectWorkshift = (id: number) => {
        setSelectedId(id);
    };

    const handlerSubmit = () => {
        save(
            modalInfoOperationsCenter.startDate?.toString() ?? '',
            modalInfoOperationsCenter.endDate?.toString() ?? '',
            modalInfoOperationsCenter.employee.map((e) => e.id),
            selectedId
        );
        setIsOpenOperationsCenterModal(false);
    };

    const handlerChangeTypeWorkshift = (e: ChangeEvent<HTMLInputElement>) => {
        let term = e.target.value;

        setSearchTerm(term);

        const operationsCenterFiltered = operationsCenter?.filter(
            (w) =>
                w.name.toLowerCase().includes(term.toLowerCase()) ||
                w.observations.toLowerCase().includes(term.toLowerCase())
        );

        setOperationsCenterCopy(operationsCenterFiltered);
    };

    const handleResetSearchTerm = () => {
        setSearchTerm('');
        setOperationsCenterCopy(operationsCenter);
    };

    useEffect(() => {
        setIsLoading(true);
        OperationsCenterRepository.getAllTypes()
            .then((types) => {
                setoperationsCenter(types);
                setOperationsCenterCopy(types);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
            });
    }, []);

    return (
        <Modal
            isOpen={isOpen}
            modalTitle='Asignar centro de operación'
            onClose={handlerCloseModal}
            onSubmit={handlerSubmit}
            disableSubmit={selectedId === -1}
            widthCustom='700px'
        >
            <div className='modal-body' style={{ paddingBottom: 0, minHeight: 200 }}>
                {isLoading ? (
                    <div className='col-3'>
                        <h5 className='card-title placeholder-glow'>
                            <span className='placeholder col-6'></span>
                        </h5>

                        <p className='card-text placeholder-glow'>
                            <span className='placeholder col-12 bg-dark'></span>
                        </p>

                        <p className='card-text placeholder-glow'>
                            <span className='placeholder col-7 bg-dark'></span>
                        </p>

                        <p className='card-text placeholder-glow'>
                            <span className='placeholder col-12 bg-dark'></span>
                        </p>

                        <p className='card-text placeholder-glow'>
                            <span className='placeholder col-7 bg-dark'></span>
                            <span className='placeholder col-4 bg-dark'></span>
                            <span className='placeholder col-4 bg-dark'></span>
                            <span className='placeholder col-4 bg-dark'></span>
                            <span className='placeholder col-4 bg-dark'></span>
                        </p>

                        <p className='card-text placeholder-glow'>
                            <span className='placeholder col-7 bg-dark'></span>
                            <span className='placeholder col-4 bg-dark'></span>
                            <span className='placeholder col-4 bg-dark'></span>
                            <span className='placeholder col-4 bg-dark'></span>
                            <span className='placeholder col-4 bg-dark'></span>
                        </p>
                    </div>
                ) : (
                    <div>
                        <SearchField
                            selectItemId={handlerChangeTypeWorkshift}
                            inputPlaceholder={'Buscar'}
                            labelTitle={''}
                            searchTerm={searchTerm}
                            handleResetSearchTerm={handleResetSearchTerm}
                            dataListId=''
                        />
                        <ul className='list-group '>
                            <SimpleBar
                                direction='rtl'
                                style={{
                                    width: '100%',
                                    maxHeight: 'calc(100vh - 250px)',
                                    height: 'calc(100vh - 250px)',
                                }}
                            >
                                {operationsCenterCopy.map((t) => (
                                    <li
                                        onClick={() => handlerSelectWorkshift(t.id)}
                                        className={`list-group-item d-flex justify-content-between`}
                                        style={{
                                            cursor: 'pointer',
                                        }}
                                        key={t.id}
                                    >
                                        <div className={`d-flex flex-column`}>
                                            <span
                                                className={`${
                                                    selectedId == t.id
                                                        ? 'text-primary2'
                                                        : 'text-dark'
                                                }`}
                                            >
                                                {t.name}
                                            </span>
                                            <span className='text-muted'>
                                                {t.observations}
                                            </span>
                                        </div>

                                        {selectedId == t.id && (
                                            <div>
                                                <i className='ri-checkbox-circle-fill fs-4 text-success'></i>
                                            </div>
                                        )}
                                    </li>
                                ))}
                            </SimpleBar>
                        </ul>
                    </div>
                )}
            </div>
        </Modal>
    );
};
